<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 13 16"
    fill="none"
  >
    <path
      d="M1 9.4L6.5 15L12 9.4M1 1L6.5 6.6L12 1"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'DoubleArrowIcon',
  props: {
    stroke: {
      type: String,
      default: '#5F8AA4',
    },
    strokeWidth: {
      type: [String, Number],
      default: 1,
    },
    width: {
      type: [String, Number],
      default: 13,
    },
    height: {
      type: [String, Number],
      default: 16,
    },
  },
};
</script>
